import {
  EMAIL_VARIFICATION_REQUEST,
  EMAIL_VARIFICATION_SUCCESS,
  EMAIL_VARIFICATION_ERROR,
} from "./actions";

const initialState = {
  requesting: false,
  successful: false,
  uid: undefined,
  token: undefined,
  error: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case EMAIL_VARIFICATION_REQUEST:
      return {
        uid: action.uid,
        token: action.token,
        error: false,
        requesting: true,
        successful: false,
      };

    case EMAIL_VARIFICATION_SUCCESS:
      return {
        error: false,
        requesting: false,
        successful: true,
      };

    case EMAIL_VARIFICATION_ERROR:
      return {
        ...state,
        error: true,
        requesting: false,
        successful: false,
      };

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/pages/confirmemail/reducer.js